function getSelector(object) {
  if (object != null && object.styledComponentId) {
    return "." + object.styledComponentId;
  }

  return "";
}

export { getSelector as a };